// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/animate.min.css
// module id = 428
// module chunks = 11